import { NavLink } from "react-router-dom";
import { NavButtonTypes } from "./nav.types";
import Icon from "../../../icons/main";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import styled from "@mui/system/styled";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Fade } from "@mui/material";
export const StyledNavLink = styled(NavLink)(() => ({
  width: "100%",
  color: "#1C1C1C",
  textDecoration: "none",
}));
const CustomNavLink = ({
  target,
  iconName,
  text,
  expanded,
}: NavButtonTypes) => {
  const isSmallScreen = useMediaQuery("(max-width:600px)");

  return (
    <StyledNavLink to={target} aria-label={text + "navigation button"}>
      <Box
        sx={{
          display: "flex",
          gap: "6px",
          position: "relative",
          left: "24px",
        }}
      >
        <Box
          sx={{
            position: "relative",
            top: "0.3rem",
          }}
        >
          {Icon[iconName]({
            width: {
              xs: "1.25rem",
            },
            height: {
              xs: "1.25rem",
            },
            color: "#D9D9D9",
            strokeWidth: "0.8",
            circle: false,
            strokeColor: "black",
          })}
        </Box>

        {(expanded || isSmallScreen) && (
          <Fade in={expanded} timeout={1000}>
            <Typography
              variant="subtitle1"
              sx={{
                position: "relative",
                top: "6px",
                opacity: expanded ? "1" : "0",
                transition: "opacity 0s ease-in-out",
              }}
            >
              {text}
            </Typography>
          </Fade>
        )}
      </Box>
    </StyledNavLink>
  );
};
export default CustomNavLink;
